module.exports = __webpack_public_path__ + "img/trending-news-dark-1.76bf5b1c.jpg";